"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserEntities {
}
exports.UserEntities = UserEntities;
//# sourceMappingURL=UserEntities.js.map